import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetInput, IGetResponse, IAgentSurveyClient } from 'interfaceAdapter/gatewaySchemas/IAgentSurveyClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AgentSurveyClient implements IAgentSurveyClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, matchId } = input;
        const PATH = `${API_LOCATION_URL}/agent/survey?match_id=${matchId}`;
        const method = 'GET';

        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
